module.exports = __webpack_public_path__ + "static/VerticalPull-SquatPull-9f62e6ff913f4f2198b5d050cb874882.mp4";